import { useLingui } from '@lingui/react';
import { createErrorMessages } from '@wkda/carlead-creation-form';
import { ServerErrorHandlerFactory, ServerErrorParserFactory } from '@wkda/funnel-utils';
import { createContext, useContext, useMemo, useState } from 'react';
import { DefaultErrorHandler, DuplicatedCarleadErrorHandler, ValidationDTOErrorHandler } from '../../CarleadCreationServerErrorHandler/CarleadCreationServerErrorHandler';
import { jsx as _jsx } from "react/jsx-runtime";
const CarleadServerResponseErrorsContext = /*#__PURE__*/createContext(null);
export function CarleadServerResponseErrorsProvider(_ref) {
  let {
    children
  } = _ref;
  const [error, setError] = useState(() => {
    return {
      type: 'NO_ERRORS'
    };
  });
  const value = useMemo(() => {
    return {
      error,
      setError
    };
  }, [error]);
  return /*#__PURE__*/_jsx(CarleadServerResponseErrorsContext.Provider, {
    value: value,
    children: children
  });
}
export function useCarleadConflicts() {
  const carleadErrors = useContext(CarleadServerResponseErrorsContext);
  const {
    i18n
  } = useLingui();
  const errorMessages = createErrorMessages(i18n);
  if (!carleadErrors) {
    throw new Error('useCarleadConflicts must be used within CarleadServerResponseErrorsProvider');
  }
  return {
    getSubmissionErrors(error) {
      return getSubmissionErrors(error, errorMessages);
    },
    ...carleadErrors
  };
}
function getSubmissionErrors(error, errorMessages) {
  const responseError = parseResponseError(error);
  const carleadCreationServerErrorHandlers = new ServerErrorHandlerFactory(
  //order is important, add more specific handlers first
  [new DuplicatedCarleadErrorHandler(), new ValidationDTOErrorHandler()], new DefaultErrorHandler());
  const handler = carleadCreationServerErrorHandlers.getHandler(responseError);
  return handler.handleError(responseError, errorMessages);
}
function parseResponseError(error) {
  const parserFactory = new ServerErrorParserFactory();
  const parser = parserFactory.getParser(error);
  return parser.parse(error);
}